export enum ContextHomeProp {
  NONE = "NONE",
  DEFAULT = "DEFAULT",
  SMALL_RANCH = "SMALL_RANCH",
  MEDIUM_RANCH = "MEDIUM_RANCH",
  LARGE_RANCH = "LARGE_RANCH",
  THREE_STORY = "THREE_STORY",
  TWO_STORY = "TWO_STORY",
}
